/* eslint-disable @typescript-eslint/no-shadow */
import { NoContentBox } from '@upright/ui/common/generic/layout/no-content-box';
import { impactCarouselMobileBreakPoint } from '@upright/ui/common/upright/core/impact-carousel/breakpoints';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ReactNode, CSSProperties } from 'react';
import styled from 'styled-components';

interface Props {
  title: ReactNode;
  children: JSX.Element;
  topColor?: string;
}

export function GenericOverlayBox(props: Props) {
  const layout = useCarouselLayout();

  const fullArea = layout.fullArea();
  const leftBoxes = layout.boxesArea(Side.LEFT);
  const rightBoxes = layout.boxesArea(Side.RIGHT);

  function getBoxesStyle() {
    const width = rightBoxes.x2 - leftBoxes.x1;
    if (fullArea.width < impactCarouselMobileBreakPoint) {
      const topTitlesArea = layout.topDescriptionsArea();
      const style: CSSProperties = {
        left: leftBoxes.x1,
        width,
        top: topTitlesArea.y1 + 10,
      };
      return style;
    } else {
      const style: CSSProperties = {
        left: leftBoxes.x1,
        width,
        top: leftBoxes.y1,
        height: leftBoxes.height,
      };
      return style;
    }
  }

  // reference area for drawing box
  const style = getBoxesStyle();

  const bgStyle: CSSProperties = {
    left: fullArea.x1,
    width: fullArea.width,
    top: fullArea.y1,
    height: fullArea.height,
  };
  return (
    <>
      <Background style={bgStyle} />
      <Wrapper style={style}>
        <NoContentBox title={props.title} topBlockColor={props.topColor}>
          {props.children}
        </NoContentBox>
      </Wrapper>
    </>
  );
}

const Background = styled.div`
  background-color: rgb(255, 255, 255, 0.8);
  position: absolute;
`;

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
`;
